module.exports = __webpack_public_path__ + "img/remove-circle-outline-dark.3a932d55.svg";